import { Paragraph, ContentSection, Header1, Header3, GridColumnsContainer, Container, Image, RichContentWrapper, PageWrapper, Spacing, HighlightBar, ButtonLink, GridColumn, Header4} from '@aaa/muse-ds'
import React, { useEffect, useState } from 'react';
import SubmissionFormComponent from './components/SubmissionFormComponent';
import CompletionComponent from './components/CompletionComponent';
import BannerErrorComponent from './components/BannerErrorComponent';
import { getClub } from './utils/cookie.utils';
import {  LogLinkClick, logPageView } from './utils/logging.utils';


function App() {

  const clubCode = getClub();
  const [error, setError] = useState("")
  const [memberName, setMemberName] = useState("");

  useEffect(() => {

    // Log the page view
    logPageView("Hertz", window.location.hostname, "Hertz Premier Gold", clubCode); 
  }, []);

  const joinHGPRNow = (e)=>{

    e.preventDefault();

    LogLinkClick("Hertz",window.location.hostname, "Hertz Premier Gold","Join Hertz Gold","https://www.aaa.com/HertzPremier","AAA Member: Join HGPR Now").finally(()=>{
      // Go to the Hertz Gold page
      window.location.href="https://www.aaa.com/HertzGold"
    });

  }

  const joinHertzPremier = (e)=>{

    e.preventDefault();

    LogLinkClick("Hertz",window.location.hostname, "Hertz Premier Gold","Join Hertz Premier","https://www.aaa.com/HertzPremier","AAA Premier Member: Join HGPR Now").finally(()=>{
      // Go to the Hertz Premier page
      window.location.href="https://www.aaa.com/HertzPremier"

    }); 
  }

  const upgradeToFiveStarStatus = (e)=>{

    e.preventDefault(); 

    LogLinkClick("Hertz",window.location.hostname, "Hertz Premier Gold","Upgrade to Five Star","#FormStart","Upgrade to Five Star Status").finally(()=>{

      // Go to the Form Start anchor
      window.location.href="#FormStart"
    });
  }


  return <PageWrapper>
    <header>
      <ContentSection
        fullWidth
        height="60vh"
        imgAlt="AAA Premier Members: Get exclusive benefits with Hertz Gold Plus Rewards"
        imgSrc="hertz-hero-image.png"
        overlay
      >
        <Container
          noPadding
          width="980"
        >
          <Header1
            bold
            color="#ffffff"
            serif
            shadow
          >
            AAA Members Get More with Hertz Gold Plus Rewards<sup>&reg;</sup> Benefits.
          </Header1>
          <Paragraph
            color="#ffffff"
            shadow
            spacing

          >
            AAA Premier members upgrade to Hertz Five Star<sup>&reg;</sup> status.</Paragraph>
        </Container>
      </ContentSection>
      <HighlightBar
        highlightBarItems={[
          {
            ariaLabel: 'Join for Free',
            label: 'Join for Free'
          },
          {
            ariaLabel: '1 Free rental day*',
            label: '1 Free rental day*'
          },
          {
            ariaLabel: 'Earn points',
            label: 'Earn points'
          }
        ]}
        theme="Hertz"
      />
    </header>
    <ContentSection>

      <Container
        centerAlignContent
        noPadding
        width="980"
      >
        <Header3 spacing>As a AAA Member, get exclusive benefits with Hertz Gold Plus Rewards<sup>&reg;</sup>*</Header3>

        <RichContentWrapper spacing>
        <Paragraph>Get to your Let&apos;s Go moment. Wherever the destination, it starts with top-rated vehicles to fit every traveler&apos;s needs. Enjoy a seamless car rental experience and go wherever the road may lead.</Paragraph>
        </RichContentWrapper >
        <GridColumnsContainer
          spacing
          columnL="6"
          columnS="6">
          <GridColumn>

            <RichContentWrapper spacing>
              <Header4>AAA Members:</Header4>
              <ul>
                <li>1 Free rental day*</li>
                <li>Skip the counter and go straight to your car<sup>1</sup></li>
                <li>Choose from a wide selection of vehicles</li>
                <li>Drop the keys and go at the rental car return</li>
              </ul>
            </RichContentWrapper >
            <RichContentWrapper spacing>
              <Paragraph>
              <ButtonLink href="https://www.aaa.com/HertzGold" action={joinHGPRNow} >AAA Member: Join HGPR Now</ButtonLink>
                </Paragraph>
            </RichContentWrapper >
          </GridColumn>
          <GridColumn>

            <RichContentWrapper spacing>
              <Header4>AAA Premier Members Only:</Header4>
              <ul>
                <li>1 Free rental day*</li>
                <li>Skip the counter and go straight to your car<sup>1</sup></li>
                <li>Choose from a wider selection of cars</li>
                <li>Drop the keys and go at the rental return</li>
                <li><i>Complimentary Hertz Five Star<sup>&reg;</sup> upgrade status<sup>**</sup></i></li>
                
                <li><i>Earn 25% more points toward free rental days and upgrades</i></li>
                <li><i>Earn one-car class upgrade.**</i></li>
                
              </ul>
            </RichContentWrapper >
            <RichContentWrapper spacing>
              <Paragraph>
                <ButtonLink href="https://www.aaa.com/HertzPremier" action={joinHertzPremier}>AAA Premier Member: Join HGPR Now</ButtonLink>
                </Paragraph>
              <Paragraph>
                Existing HGRP Members with AAA Premier membership:
                </Paragraph>
              <Paragraph>
                <ButtonLink href="#FormStart" action={upgradeToFiveStarStatus}>Upgrade to Five Star Status</ButtonLink>
                </Paragraph>
            </RichContentWrapper >
          </GridColumn>

        </GridColumnsContainer>
      </Container>
    </ContentSection>
    <ContentSection
      backgroundColor="#edeef2">
        <span id="FormStart"></span>
      <Container
        noPadding
        width="980"
      >

        <BannerErrorComponent close={() => setError("")} error={error}></BannerErrorComponent>

        <GridColumnsContainer
          columnL="6"
          columnS="6"
        >
          <div>
            {memberName == "" ? <SubmissionFormComponent onError={setError} onSuccess={setMemberName} /> : <CompletionComponent memberName={memberName} />}
          </div>
          <div style={{ textAlign: "right" }}>
            <Image
              alt="This is an image of New England"
              extraClass=""
              height=""
              image={{
                state: 'IMAGE_DEFAULT'
              }}
              placeholderSrc="hertz-side-image.png"
              src="hertz-side-image.png"
              width="400px"
            />
          </div>

        </GridColumnsContainer>

      </Container>
    </ContentSection>

    <ContentSection >

      <Container
        noPadding
        width="980"
      >
        <Spacing
          SpacingContainer={{
            state: 'SPACING_BASE',
            title: 'Components/Atoms/Spacing'
          }}
        >
          <Paragraph fontSize={"XXS"} >*Valid for new Hertz Gold Plus Rewards (HGPR) members only. Points for 1 free day will be added to HGPR members&apos; profile after first paid Gold rental.</Paragraph>
          <Paragraph fontSize={"XXS"} >**Upgrade is based on validation of HGPR number and AAA Premier membership. Upon upgrade, eligible AAA Premier members will remain at Hertz Five Star status as long as AAA Premier members&apos; status is maintained. Free rental day excludes taxes and fees. Car class upgrade is subject to availability and applies to Compact, Intermediate, Standard and Full-size rentals with a maximum upgrade to a Premium.</Paragraph>
          <Paragraph fontSize={"XXS"} ><sup>1</sup>Skip the counter is available at select locations. Additional terms and exclusions apply.</Paragraph>
          <span style={{ opacity: 0.3, textAlign: "center" }}>
            <Paragraph fontSize={"XXS"} >
              Build Date: {new Date().toString()}
            </Paragraph>
          </span>
        </Spacing>
      </Container>
    </ContentSection>
  </PageWrapper>
}

export default App;
